import { render, staticRenderFns } from "./r-store-bundle-dialog.vue?vue&type=template&id=19ff6afe&scoped=true"
import script from "./r-store-bundle-dialog.vue?vue&type=script&lang=js"
export * from "./r-store-bundle-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-store-bundle-dialog.vue?vue&type=style&index=0&id=19ff6afe&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ff6afe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19ff6afe')) {
      api.createRecord('19ff6afe', component.options)
    } else {
      api.reload('19ff6afe', component.options)
    }
    module.hot.accept("./r-store-bundle-dialog.vue?vue&type=template&id=19ff6afe&scoped=true", function () {
      api.rerender('19ff6afe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/product/r-store-bundle-dialog.vue"
export default component.exports